module.exports = __webpack_public_path__ + "img/file-word.7f44e67d.png";